import { useState, useRef, useEffect } from 'react'

export default function ScrollOverflowText({ 
    text = 'Enter text here', 
    className = '' 
}) {
    const textRef = useRef(null)
    
    const [isTextOverflowing, setIsTextOverflowing] = useState(false)
    const [overflowAmount, setOverflowAmount] = useState(0)

    useEffect(() => {
        if (textRef.current) {
            const isOverflowing = textRef.current.scrollWidth > textRef.current.clientWidth
            
            setIsTextOverflowing(isOverflowing)
            
            if (isOverflowing) {
                const overflow = textRef.current.scrollWidth - textRef.current.clientWidth + 4 // Add a little extra padding to the overflow
                setOverflowAmount(overflow)
            } else {
                setOverflowAmount(0)
            }
        }
    }, [text])

    return (
        <div className="w-full overflow-hidden">
            <div 
                ref={textRef}
                className={`
                    whitespace-nowrap text-left
                    ${className} 
                    ${isTextOverflowing ? 'animate-marquee' : ''}
                `}
                style={isTextOverflowing ? { '--overflow-amount': `-${overflowAmount}px` } : {}}
            >
                {text}
            </div>
        </div>
    )
}